// src/index.ts
var DESIGN_TOKENS = {
  colors: {
    primary: "#4D5D32",
    // Bitio sage green
    accent: "#FA9EAF",
    // Bitio soft pink
    background: "#FAFAFA",
    // Off-white
    foreground: "#1A1C17",
    // Near-black
    muted: "#6B7280",
    // Gray for secondary text
    border: "#E5E7EB",
    // Light gray border
    error: "#DC2626",
    // Red for errors
    success: "#059669"
    // Green for success
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSizeBase: "14px",
    fontSizeSm: "12px",
    fontSizeLg: "16px",
    fontSizeXl: "18px",
    lineHeight: 1.5
  },
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px"
  },
  borderRadius: {
    sm: "4px",
    md: "8px",
    lg: "16px",
    full: "9999px"
  },
  shadows: {
    sm: "0 1px 2px rgba(0,0,0,0.05)",
    md: "0 4px 6px rgba(0,0,0,0.07)",
    lg: "0 10px 15px rgba(0,0,0,0.1)",
    xl: "0 20px 25px rgba(0,0,0,0.15)"
  },
  transitions: {
    fast: "150ms ease",
    normal: "250ms ease",
    slow: "350ms ease"
  }
};
var STRINGS_SV = {
  openChat: "Chatta med oss",
  closeChat: "St\xE4ng",
  initialQuestion: "Vad beh\xF6ver du hj\xE4lp med?",
  modeSelector: {
    title: "Hur kan vi hj\xE4lpa dig?",
    chatWithUs: "Chatta med oss",
    chatWithUsDesc: "Prata direkt med v\xE5rt team",
    specBuilder: "Os\xE4ker p\xE5 vad du beh\xF6ver?",
    specBuilderDesc: "Prova v\xE5r AI-specbyggare"
  },
  introForm: {
    title: "Innan vi b\xF6rjar",
    subtitle: "Fyll i dina uppgifter s\xE5 att vi kan \xE5terkoppla om du beh\xF6ver l\xE4mna chatten.",
    name: "Namn",
    namePlaceholder: "Ditt namn",
    email: "E-post",
    emailPlaceholder: "din@email.se",
    start: "Starta chatt",
    starting: "Startar..."
  },
  slackMode: {
    connecting: "Ansluter till s\xE4lj...",
    connected: "Chattar med s\xE4lj",
    waitingForReply: "V\xE4ntar p\xE5 svar...",
    chatting: "Chattar med s\xE4lj",
    specBuilder: "Spec Builder"
  },
  placeholder: "Skriv ditt meddelande...",
  send: "Skicka",
  uploadImage: "Ladda upp bild",
  uploadFile: "Bifoga fil",
  dragDropImage: "Dra och sl\xE4pp en bild h\xE4r, eller klicka f\xF6r att v\xE4lja",
  dragDropFile: "Dra och sl\xE4pp filer h\xE4r (bilder, PDF, Word, text)",
  contactForm: {
    title: "N\xE4stan klart!",
    subtitle: "Fyll i dina uppgifter s\xE5 \xE5terkommer vi inom kort.",
    name: "Namn",
    email: "E-post",
    phone: "Telefon (valfritt)",
    company: "F\xF6retag",
    role: "Roll (valfritt)",
    submit: "Skicka f\xF6rfr\xE5gan",
    submitting: "Skickar...",
    success: "Tack! Vi \xE5terkommer snart.",
    error: "N\xE5got gick fel. F\xF6rs\xF6k igen."
  },
  projectSpec: {
    title: "Projekt\xF6versikt",
    projectName: "Projektnamn",
    targetAudience: "M\xE5lgrupp",
    features: "Funktioner",
    attachments: "Bilagor",
    technicalNotes: "Tekniska anteckningar",
    complexity: "Komplexitet",
    budget: "Budget",
    timeline: "Tidsram",
    noDataYet: "Information samlas in under samtalet...",
    tabChat: "Chatt",
    tabSpec: "Spec"
  },
  specConfirmation: {
    subtitle: "St\xE4mmer detta? Granska och bekr\xE4fta, eller forts\xE4tt f\xF6rfina.",
    summary: "Sammanfattning",
    confirm: "Ser bra ut - skicka in",
    continue: "Jag vill f\xF6rfina mer",
    complexityLow: "L\xE5g",
    complexityMedium: "Medel",
    complexityHigh: "H\xF6g"
  },
  errors: {
    networkError: "N\xE4tverksfel. Kontrollera din anslutning.",
    imageUploadFailed: "Kunde inte ladda upp bilden. F\xF6rs\xF6k igen.",
    fileUploadFailed: "Kunde inte ladda upp filen. F\xF6rs\xF6k igen.",
    fileTooLarge: "Filen \xE4r f\xF6r stor. Max 10 MB.",
    fileTypeNotAllowed: "Filtypen st\xF6ds inte. Till\xE5tna: bilder, PDF, Word, text.",
    messageFailed: "Kunde inte skicka meddelandet. F\xF6rs\xF6k igen."
  },
  leaveMessage: {
    title: "L\xE4mna ett meddelande",
    subtitle: "Fyll i dina uppgifter s\xE5 \xE5terkommer vi s\xE5 snart vi kan.",
    outsideHoursTitle: "Vi \xE4r inte tillg\xE4ngliga just nu",
    outsideHoursSubtitle: "L\xE4mna ett meddelande s\xE5 \xE5terkommer vi under kontorstid.",
    name: "Namn",
    email: "E-post",
    company: "F\xF6retag (valfritt)",
    message: "Meddelande",
    messagePlaceholder: "Beskriv vad du beh\xF6ver hj\xE4lp med...",
    submit: "Skicka meddelande",
    submitting: "Skickar...",
    success: "Tack! Vi \xE5terkommer s\xE5 snart vi kan.",
    error: "N\xE5got gick fel. F\xF6rs\xF6k igen.",
    orLeaveMessage: "eller l\xE4mna ett meddelande",
    noReplyYet: "Inget svar \xE4nnu?",
    noReplyPrompt: "L\xE4mna dina kontaktuppgifter s\xE5 \xE5terkommer vi via e-post.",
    back: "Tillbaka",
    validation: {
      nameRequired: "Namn kr\xE4vs",
      emailRequired: "E-post kr\xE4vs",
      emailInvalid: "Ogiltig e-postadress",
      messageRequired: "Meddelande kr\xE4vs"
    }
  },
  rateLimit: {
    title: "L\xE5t oss ta det h\xE4rifr\xE5n!",
    subtitle: "L\xE4mna dina kontaktuppgifter s\xE5 \xE5terkommer vi personligen."
  },
  chat: {
    reset: "Starta om",
    back: "Tillbaka"
  }
};
var STRINGS_EN = {
  openChat: "Chat with us",
  closeChat: "Close",
  initialQuestion: "What do you want to build?",
  modeSelector: {
    title: "How can we help?",
    chatWithUs: "Chat with us",
    chatWithUsDesc: "Talk directly with our team",
    specBuilder: "Not sure what you need?",
    specBuilderDesc: "Try our AI spec builder"
  },
  introForm: {
    title: "Before we start",
    subtitle: "Enter your details so we can follow up if you need to leave the chat.",
    name: "Name",
    namePlaceholder: "Your name",
    email: "Email",
    emailPlaceholder: "your@email.com",
    start: "Start chat",
    starting: "Starting..."
  },
  slackMode: {
    connecting: "Connecting to sales...",
    connected: "Chatting with sales",
    waitingForReply: "Waiting for reply...",
    chatting: "Chatting with sales",
    specBuilder: "Spec Builder"
  },
  placeholder: "Type your message...",
  send: "Send",
  uploadImage: "Upload image",
  uploadFile: "Attach file",
  dragDropImage: "Drag and drop an image here, or click to select",
  dragDropFile: "Drag and drop files here (images, PDF, Word, text)",
  contactForm: {
    title: "Almost done!",
    subtitle: "Fill in your details and we'll get back to you shortly.",
    name: "Name",
    email: "Email",
    phone: "Phone (optional)",
    company: "Company",
    role: "Role (optional)",
    submit: "Submit request",
    submitting: "Submitting...",
    success: "Thank you! We'll be in touch soon.",
    error: "Something went wrong. Please try again."
  },
  projectSpec: {
    title: "Project Overview",
    projectName: "Project Name",
    targetAudience: "Target Audience",
    features: "Features",
    attachments: "Attachments",
    technicalNotes: "Technical Notes",
    complexity: "Complexity",
    budget: "Budget",
    timeline: "Timeline",
    noDataYet: "Information is being gathered during the conversation...",
    tabChat: "Chat",
    tabSpec: "Spec"
  },
  specConfirmation: {
    subtitle: "Does this look right? Review and confirm, or continue refining.",
    summary: "Summary",
    confirm: "Looks good - submit",
    continue: "I want to refine more",
    complexityLow: "Low",
    complexityMedium: "Medium",
    complexityHigh: "High"
  },
  errors: {
    networkError: "Network error. Check your connection.",
    imageUploadFailed: "Failed to upload image. Please try again.",
    fileUploadFailed: "Failed to upload file. Please try again.",
    fileTooLarge: "File is too large. Maximum 10 MB.",
    fileTypeNotAllowed: "File type not supported. Allowed: images, PDF, Word, text.",
    messageFailed: "Failed to send message. Please try again."
  },
  leaveMessage: {
    title: "Leave a message",
    subtitle: "Fill in your details and we'll get back to you as soon as possible.",
    outsideHoursTitle: "We're not available right now",
    outsideHoursSubtitle: "Leave a message and we'll get back to you during office hours.",
    name: "Name",
    email: "Email",
    company: "Company (optional)",
    message: "Message",
    messagePlaceholder: "Describe what you need help with...",
    submit: "Send message",
    submitting: "Sending...",
    success: "Thank you! We'll get back to you as soon as possible.",
    error: "Something went wrong. Please try again.",
    orLeaveMessage: "or leave a message",
    noReplyYet: "No reply yet?",
    noReplyPrompt: "Leave your contact details and we'll get back to you via email.",
    back: "Back",
    validation: {
      nameRequired: "Name is required",
      emailRequired: "Email is required",
      emailInvalid: "Invalid email address",
      messageRequired: "Message is required"
    }
  },
  rateLimit: {
    title: "Let's take it from here!",
    subtitle: "Leave your contact details and we'll get back to you personally."
  },
  chat: {
    reset: "Start over",
    back: "Back"
  }
};
export {
  DESIGN_TOKENS,
  STRINGS_EN,
  STRINGS_SV
};
